import { useState, useMemo, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUpperPopup } from '../../store/reducers/general'
import { createNewTableItem, formatDate, getCookie } from '../../services/util'
import { useNavigate } from 'react-router-dom'
import { videoService } from '../../services/video'
import { VideoPopup } from './popup'
import { CalendarCmp } from '../calendar'
import { ProducerChat } from './chat'
import { io } from 'socket.io-client'
import 'react-day-picker/style.css'
let socket = null

const statusColors = {
    'לא התחיל': 'rgb(102, 102, 102)',
    'אני תקוע': 'rgb(200, 39, 39)',
    'חקר שוק': 'rgb(52, 215, 207)',
    'בקשר מול ספקים': 'rgb(137, 78, 0)',
    'ממתין להצעת מחיר': 'rgb(112, 0, 161)',
    'נדרש אישור הצעת מחיר': 'rgb(52, 80, 237)',
    'הועברו פרטי תשלום': 'rgb(252, 194, 17)',
    'בוצע תשלום / הוזמן /קיים': 'rgb(72, 243, 80)',
}

export function Producer({ role, part, status, videoId, isOpen, department, lastViewed }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { currentTeam } = useSelector(state => state.user)
    const user = useSelector(state => state.user)
    const [popup, setPopup] = useState('')
    const [items, setItems] = useState(part.items || [])
    const [logs, setLogs] = useState(part.logs || [])
    const [isConnected, setIsConnected] = useState(false)
    const [feedback, setFeedback] = useState(part.feedback || '')
    const totalPrice = useMemo(() => items.reduce((acc, item) => acc + Number(item.price), 0), [items])
    const accessToken = useRef(null)
    const linkRefs = useRef({})
    const logsRef = useRef(null)

    useEffect(() => {

        if (logsRef?.current?.scrollHeight) setTimeout(() => logsRef.current.scrollTop = logsRef.current.scrollHeight, 200)
    }, [logs])

    useEffect(() => {
        if (socket) {
            socket.close()
            socket = null
        }
        socket = io( process.env.NODE_ENV === 'production' ? 'saltiz-picker-server.pikme.tv' : 'http://localhost:3030', { transports: ['websocket'], withCredentials: true })
        socket.emit('validate', { videoId })
        socket.on('unauthorized', () => {
            dispatch(setUpperPopup('unauthenticated-socket'))
        })
        socket.on('disconnect', () => {
            setIsConnected(false)
        })
        socket.on('validate-finished', (token) => {
            accessToken.current = token
            setIsConnected(true)
        })
        socket.on('recieve-feedback', (feedback) => {
            setFeedback(feedback)
        })
        socket.on('select-edited', ({ itemId, key, value }) => {
            setItems(prevItems =>
                prevItems.map(item =>
                    item.id === itemId ? { ...item, [key]: value } : item
                )
            )
        })
        socket.on('links-updated', ({ itemId, links }) => {
            setItems(prevItems =>
                prevItems.map(item =>
                    item.id === itemId ? { ...item, links } : item
                )
            )
        })
        socket.on('item-added', (item) => {
            setItems(prev => [...prev, item])
        })
        socket.on('item-deleted', (itemId) => {
            setItems(prev => prev.filter(item => item.id !== itemId))
        })
        socket.on('links-updated', ({ itemId, links }) => {
            setItems(prevItems =>
                prevItems.map(item =>
                    item.id === itemId ? { ...item, links } : item
                )
            )
        })
        socket.on('item-text-edited', ({ itemId, key, value }) => {
            setItems(prevItems =>
                prevItems.map(item =>
                    item.id === itemId ? { ...item, [key]: value } : item
                )
            )
        })
        socket.on('item-alerted', ({ itemId, isAlerted }) => {
            setItems(prevItems =>
                prevItems.map(item =>
                    item.id === itemId ? { ...item, isAlerted } : item
                )
            )
        })
        if (role === 'admin') {
            socket.on('log-added', (log) => {
                setLogs(prevLogs => [...prevLogs, log])
            })
        }

        return () => {
            if (socket) {
                socket.removeAllListeners()
                socket.close()
                socket = null
            }
        }
    }, [])

    const addItem = () => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        socket.emit('add-item', { item: createNewTableItem(), videoId, token: accessToken.current })
    }

    const deleteItem = (itemId) => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        socket.emit('delete-item', { itemId, videoId, token: accessToken.current })
    }

    const updateLinks = (itemId, action, link) => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        let links = items.find(item => item.id === itemId).links
        if (action === 'add') {
            const l = linkRefs.current[itemId].value
            try {
                new URL(l)
            }
            catch {
                return dispatch(setUpperPopup('invalid-link'))
            }
            links.push(l)
            linkRefs.current[itemId].value = ''
        }
        else links.splice(links.indexOf(link), 1)
        socket.emit('edit-item-links', { itemId, links, videoId, token: accessToken.current })
    }

    const editItemTextLocal = (ev, itemId, key) => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        setItems(prevItems =>
            prevItems.map(item =>
                item.id === itemId ? { ...item, [key]: ev.target.value } : item
            )
        )
    }

    const saveItemText = (itemId, key, value) => {
        console.log(key)
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        socket.emit('edit-item-text', { itemId, key, value, videoId, token: accessToken.current })
    }

    const editSelect = (ev, itemId, key, itemName) => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        const log = key === 'workerId' ? {
            id: Date.now(),
            from: user.name,
            to: ev.target.value === 'לא משויך' ? 'לא משויך' : department.members[ev.target.value].name,
            item: itemName,
            date: new Date(),
        } : false
        socket.emit('edit-item-select', { itemId, key, value: ev.target.value, videoId, token: accessToken.current, log })
    }

    const editFeedback = () => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        socket.emit('edit-feedback', { feedback, videoId, token: accessToken.current })
    }

    const handleButtonClick = async (ns) => {
        setPopup('')
        dispatch(setUpperPopup('loader'))
        try {
            await videoService.editVideo({ partToEdit: 'scripter', videoId, teamId: currentTeam._id, edit: { feedback }, nextSteps: ns })
            dispatch(setUpperPopup('video-edited'))
            navigate('/')
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const editAlerted = (itemId, isAlerted) => {
        if (!isConnected) return dispatch(setUpperPopup('error-socket'))
        const adminEmail = currentTeam.members.find(member => member.roles.includes('admin'))?.email
        socket.emit('edit-item-alerted', {
            itemId,
            isAlerted,
            videoId,
            token: accessToken.current,
            adminEmail,
            workerName: user.name,
            itemName: items.find(item => item.id === itemId).item
        })
    }

    const getAlerted = (isAlerted, itemId) => {
        if (role === 'admin' && isAlerted) return <span onClick={() => editAlerted(itemId, false)} class="material-symbols-outlined mark-for-admin">check</span>
        if (role !== 'admin' && !isAlerted) return <span onClick={() => editAlerted(itemId, true)} class="material-symbols-outlined mark-for-admin">notification_important</span>
        return null
    }

    const buttons = useMemo(() => {
        const buttons = []

        if (role !== 'admin') {
            buttons.push(<div onClick={() => setPopup('forward-as-success')} className='green' key='forward-as-success'>העבר כהצלחה</div>)
            buttons.push(<div onClick={() => setPopup('forward-as-failure')} className='red' key='forward-as-failure'>העבר ככשלון</div>)
        }
        else {
            if (status.status.includes('forward')) buttons.push(<div onClick={() => setPopup('returned-for-changes')} key='reject' className='red' name='returned-for-changes'>החזר אחורה לתיקון</div>)
            if (status.level === 'producer') buttons.push(<div onClick={() => setPopup('archive')} key='archive' className='green' name='archive'>העבר לארכיון</div>)
        }

        if (!buttons.length) return null
        return <div className='buttons-wrapper'>
            <p>{role === 'admin' ? 'אפשרויות' : 'הגש לבדיקה'}</p>
            <div className='buttons'>
                {buttons}
            </div>
        </div>

    }, [role])

    return <div id='scripter'>
        {isOpen && <div className='main3-back'>

            <h3 style={{ marginTop: '15px' }}>טבלת פריטים</h3>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <td>פריט</td>
                            <td>תיאור</td>
                            <td>קישורים</td>
                            <td>כמה הדבר חשוב?</td>
                            <td>מחיר</td>
                            {department && <td>חבר צוות</td>}
                            <td>סטטוס</td>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => <tr key={item.id} style={{ opacity: (item.workerId === user._id || (role === 'admin' && item.isAlerted)) ? 1 : 0.5 }}>
                            <td>
                                <textarea style={{ marginTop: '25px' }} placeholder='מה צריך?' type='text' value={item.item} onChange={(ev) => editItemTextLocal(ev, item.id, 'item')} onBlur={(ev) => saveItemText(item.id, 'item', ev.target.value)} />
                                <div className="delete-absolute" onClick={() => deleteItem(item.id)}><span className="material-symbols-outlined">delete</span></div>
                                {getAlerted(item.isAlerted, item.id)}
                                {lastViewed < new Date(item.lastUpdatedAt) && <span className="yellow-text item-left">(חדש)</span>}
                            </td>
                            <td>
                                <textarea placeholder='תיאור' type='text' onBlur={(ev) => saveItemText(item.id, 'info', ev.target.value)} value={item.info} onChange={(ev) => editItemTextLocal(ev, item.id, 'info')} />
                            </td>
                            <td>
                                <div className='table-link'>
                                    {item.links?.map((link) => <div className="single-link" key={link}>
                                        {link && <span onClick={(ev) => { ev.stopPropagation(); navigator.clipboard.writeText(link); dispatch(setUpperPopup('copied')) }} className="material-symbols-outlined">content_copy</span>}
                                        {<span className="material-symbols-outlined" onClick={(ev) => { ev.stopPropagation(); updateLinks(item.id, 'delete', link) }}>delete</span>}
                                        <a href={link} target='_blank'>{link.split('://')[1]?.slice(0, 8)}</a>
                                    </div>
                                    )}
                                    <div className="link-input-wrapper">
                                        <span className="material-symbols-outlined clickable add-link" onClick={() => updateLinks(item.id, 'add')}>add</span>
                                        <input
                                            placeholder='https://...'
                                            type='text'
                                            ref={el => {
                                                if (el) linkRefs.current[item.id] = el
                                            }}
                                        />
                                    </div>

                                </div>
                            </td>
                            <td className={'table-status ' + (item.importance === 'עדיף שיהיה' ? 'orange' : item.importance === 'אי אפשר בלעדיו' ? 'red' : 'green')}>
                                <select className={'table-status ' + (item.importance === 'עדיף שיהיה' ? 'orange' : item.importance === 'אי אפשר בלעדיו' ? 'red' : 'green')} value={item.importance} onChange={(ev) => editSelect(ev, item.id, 'importance')}>
                                    <option value='לא חובה'>לא חובה</option>
                                    <option value='עדיף שיהיה'>עדיף שיהיה</option>
                                    <option value='אי אפשר בלעדיו'>אי אפשר בלעדיו</option>
                                </select>
                            </td>
                            <td>
                                <input placeholder='מחיר' type='number' value={item.price} onBlur={(ev) => saveItemText(item.id, 'price', ev.target.value)} onChange={(ev) => editItemTextLocal(ev, item.id, 'price')} />
                            </td>
                            {department && <td>
                                <select value={item.workerId} onChange={(ev) => { editSelect(ev, item.id, 'workerId', item.item); }}>
                                    <option value='לא משויך'>לא משויך</option>
                                    {Object.values(department.members).map(member => <option value={member._id} key={member._id}>{member.name}</option>)}
                                </select>
                            </td>}
                            <td className='table-status' style={{ backgroundColor: statusColors[item.status] }}>
                                <select style={{ backgroundColor: statusColors[item.status], fontSize: '16px' }} value={item.status} onChange={(ev) => editSelect(ev, item.id, 'status')}>
                                    {Object.keys(statusColors).map(status => <option value={status} key={status}>{status}</option>)}
                                </select>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
                <div className="add" onClick={addItem}>+ הוסף פריט</div>
            </div>

            <h3 style={{ margin: '10px 0 30px 0' }}>מחיר כולל : <span className='white'>{totalPrice}₪</span></h3>

            {department && <ProducerChat lastViewed={lastViewed}
                isNew={lastViewed < new Date(part.lastUpdatedFields.chat)}
                initialMessages={part.chat}
                socket={socket}
                videoId={videoId}
                token={accessToken.current}
                isConnected={isConnected}
                openPopup={() => dispatch(setUpperPopup('error-socket'))} user={user}
            />}

            {role === 'admin' && <>
                <h3>היסטוריית העברת משימות</h3>
                <div className='logs' ref={logsRef}>
                    {logs.length ? logs.map(log => <div key={log.id}>
                        <p>פריט {log.item} הועבר על ידי {log.from} ל{log.to}</p>
                        <span>{formatDate(log.date)}</span>
                    </div>) : <p>אין היסטוריה כרגע</p>}
                </div>
            </>}

            <CalendarCmp
                teamGmail={currentTeam.teamGmail}
                isActive={true}
            />

            <h3>הערות ומשוב {lastViewed < new Date(part.lastUpdatedFields.feedback) && <span className="yellow-text"> (חדש)</span>}</h3>
            <textarea className='area' value={feedback} placeholder="שיח עם אדמין הצוות" onBlur={editFeedback} onChange={(ev) => setFeedback(ev.target.value)} />

            {buttons}

            {popup && <VideoPopup close={() => setPopup('')} type={popup} onConfirm={handleButtonClick} />}
        </div>}
    </div>
}